import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useNavigateWithQuery from "./useNavigateWithQuery";
import { useAppStore } from "store/store";
import useFlowRedirect, {
  getPaxSessionRelativeUrl,
  getSessionRelativeUrl,
} from "./useFlowRedirect";

const useSessionRootRedirect = () => {
  const location = useLocation();

  const navigate = useNavigateWithQuery();

  const sessionId = useAppStore((state) => state.sessionId);

  const sessionRelativeUrl = getSessionRelativeUrl(sessionId);

  const paxSessions = useAppStore((state) => state.paxSessions);

  const [, redirect] = useFlowRedirect(() => {
    // this is fallback redirect, when useFlowRedirect
    // is unsure where to send this user

    if (paxSessions.length === 1) {
      // there is only 1 pax session
      // => send to checklist navigation
      navigate(
        `${getPaxSessionRelativeUrl(
          sessionId,
          paxSessions[0].paxSessionId
        )}/checklist`
      );
      return;
    }

    // more than 1 pax session and consent response was provided,
    // as we check it as part of the useFlowRedirect hook
    // => send to select passenger
    navigate(`${sessionRelativeUrl}/select-passenger`);
  });

  useEffect(() => {
    // check if exactly at session root, ie /session/{sessionId}/
    const isSessionRootPath =
      location.pathname === sessionRelativeUrl ||
      location.pathname === `${sessionRelativeUrl}/`;

    if (isSessionRootPath) {
      redirect();
    }
  }, [location, sessionRelativeUrl, redirect]);
};

export default useSessionRootRedirect;
